export default __webpack_public_path__ + "static/media/bank-saman.262c8619.svg";